export default {
  apiSchema: process.env.VUE_APP_API_SCHEMA || 'http',
  apiHost: process.env.VUE_APP_API_HOST || 'localhost',
  apiPort: process.env.VUE_APP_API_PORT || 8081,
  apiPath: process.env.VUE_APP_API_PATH || 'api/',
  get apiUrl() {
    return `${this.apiSchema}://${this.apiHost}:${this.apiPort}/${this.apiPath}`.slice(0, -1);
  },
  get publicUrl() {
    return `${this.apiSchema}://${this.apiHost}:${this.apiPort}/public`;
  },
  krnapOAuth2: {
    endpoint: 'https://id.krnap.cz/oauth/login',
    clientId: '02be2a7982be48bca37c18df8a4bc537f6ca64c65a11a91c7864b4826fdbee8d',
    redirectUri: process.env.VUE_APP_OAUTH_REDIRECT || 'http://localhost:8080/exchange-token',
    get getUrl() {
      const krnapOAuth2Url = new URL(this.endpoint);
      krnapOAuth2Url.searchParams.set('client_id', this.clientId);
      krnapOAuth2Url.searchParams.set('redirect_uri', this.redirectUri);
      return krnapOAuth2Url
    }
  },
  appVersion: process.env.VUE_APP_APP_VERSION || 'dev'
}
